import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AiChatService } from '@portal/app/shared/components/ai-assistant-panel/ai-chat.service';
import { MiaContextService } from '@portal/app/shared/services/mia-context.service';
import { renderAgentMarkdown } from '@portal/app/shared/components/ai-assistant-panel/helpers/agent-markdown';
import { PortalFeedbackThumbsComponent } from '@portal/app/shared/components/ai-assistant-panel/shared/feedback-thumbs.component';

@Component({
  selector: 'portal-block-response',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PortalFeedbackThumbsComponent],
  templateUrl: './block-response.component.html',
  host: { class: 'contents' }
})
export class PortalBlockResponseComponent {
  readonly content = input.required<string>();
  /** Per-message LangSmith run id. May briefly be undefined between the
   * `messages/partial` flush and the final `values` reconciliation — in that
   * window we fall back to the chat-service-level `lsRunId` (the most recent
   * `metadata` event captured straight off the SSE wire). */
  readonly lsRunId = input<string | undefined>();
  /** False for the streaming-draft preview (no thumbs until turn finalizes). */
  readonly showFeedback = input(true);

  readonly #sanitizer = inject(DomSanitizer);
  readonly #chat = inject(AiChatService);
  protected readonly miaContext = inject(MiaContextService);

  protected readonly rendered = computed(() =>
    this.#sanitizer.bypassSecurityTrustHtml(renderAgentMarkdown(this.content()))
  );

  protected readonly effectiveLsRunId = computed(
    () => this.lsRunId() ?? this.#chat.lsRunId() ?? undefined
  );
}
